<template>
  <div class='services w-full text-xl'>
    <!--<h1>All Legal services</h1>
    <h1>URL: [ {{ services_url }} ] </h1> -->
    <p v-if="isLoadingList" role="status">
      Loading all services...
    </p>
    <template v-else>
      <div class='hide-for-print results accordion accordion-flush pt-5' id="accordionFlushExample" role="list">
        <!-- Pass individual object to a ServiceCard -->
        <ServiceCard v-for="(service, index) in rankedServices" :key="service.id" :service="service" :aria-setsize="rankedServices.length" :aria-posinset="index + 1" role="listitem" />
      </div>
      <!-- Printable area -->
      <div class="show-for-print">
        <PrintView :search_result="rankedServices" />
      </div>

      <div class="flex justify-end mt-5 mb-5">
        <button class="btn btn-blue m-2 text-xl sm:text-3xl hide-for-print" type="button" @click="printResult()">Print results</button>
      </div>
    </template>

  </div>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
//import { ref, onMounted } from 'vue'
import ServiceCard from '../components/ServiceCard.vue';
import PrintView from '../components/PrintView.vue';


export default {
  components: {
    ServiceCard,
    PrintView
  },
/*   setup () {
    const isLoadingList = ref(false);

    onMounted (async () => {
      isLoadingList.value = true;
      try {

      } finally {

      }
    })
  }, */
  data() {
    return {
      services_url: process.env.VUE_APP_SERVICES_BASE_URL,
      questions_url: process.env.VUE_APP_QUESTIONS_BASE_URL,
      services: [],
      isLoadingList: false
    }
  },
  async mounted() {
    this.isLoadingList = true;
    try {
      const response = await axios.get(process.env.VUE_APP_SERVICES_BASE_URL);
      console.log(response.status);
      this.services = response.data;
    } catch (error) {
      console.error(error);
    } finally {
      this.isLoadingList = false;
    }
  },
  computed: {
    rankedServices: function () {
      //try {
        const myList = _.orderBy(this.services, 'service_name', 'asc')
      // } finally {
        //this.upDateLoading();
        return myList;
      //}  
    }


  },
  methods: {
    /*
        Generate Report using refs and calling the
        refs function generatePdf()
    */
/*     generateResultsPDF () {
        this.$refs.html2Pdf.generatePdf()
    }, */
    printResult() {
      /* force a print window and hide unwanted content. Must be reproduced on all service page */
      document.title='Community legal services';
      window.print();
    },
    upDateLoading() {
      this.isLoadingList = false;
    }
  } 
}
</script>

<style scoped>
/**  
.results {
  text-align: left;
  max-width: 1240px;
  margin: auto;
}
.services {
  text-align: left;
  max-width: 1240px;
  margin: auto;
  margin-bottom: 20px;
}
*/
</style>